export default __webpack_public_path__ + "static/char-s-39-en-3788019b6da0ca34856d854ecc77d44b.png";